<template>
    <div class="content">
        <div class="row d-flex" id="inputArea" v-if="page!=='numerator'">
            <input type="text" v-model="numberInput" @input="searchGsm($event.target.value)" name="code" value="" class="display" />
            <span class="material-icons m-auto pr-2 backspace" @click="deleteNumber()">backspace</span>
        </div>
        <div class="row d-flex" style="border-bottom: 1px solid #4F4F4F;" v-else>
            <input type="text" disabled v-model="numberInput" name="code" value="" class="display" />
        </div>
        
        <table id="keypad">
            <tbody>
                <tr>
                    <td @click="addCode('1')">1</td>
                    <td @click="addCode('2')">2</td>
                    <td @click="addCode('3')">3</td>
                </tr>
                <tr>
                    <td @click="addCode('4')">4</td>
                    <td @click="addCode('5')">5</td>
                    <td @click="addCode('6')">6</td>
                </tr>
                <tr>
                    <td @click="addCode('7')">7</td>
                    <td @click="addCode('8')">8</td>
                    <td @click="addCode('9')">9</td>
                </tr>
                <tr>
                    <td @click="addCode('*')">*</td>
                    <td @click="addCode('0')">0</td>
                    <td @click="addCode('#')">#</td>
                </tr>
            </tbody>
        </table>

        <div class="row m-0" v-if="page==='header'">
            <span class="material-icons call-icon"  @click="call">phone</span>
        </div>
        <div class="row m-0" v-else-if="page==='forward'">
            <button class="btn forward-btn" @click="transfer">Yönlendir</button>
        </div>
    </div>
</template>
<script>

import axios from 'axios'
import { mapState, mapGetters } from 'vuex'
import Sip from '@/components/sip'

export default {
    name: 'numerator',
    props:["page","status"],
    components:{
        Sip
    },
    data (){
        return{
            numberInput:"",
            personArray:[],
            bottom:false,
            pagingSize:30,
            pagingOffset:0,
            filter:""
        }
    },
    watch: {
        bottom(bottom) {
            if (bottom) {
                this.pagingSize+=this.pagingSize
                this.searchGsm(this.numberInput)
            }
        },
        status:function(){
            
        }
    },
    methods:{
        addCode(key){
            if(this.page === 'numerator'){
                this.$root.$refs.sip.dtmfSend(key)
                this.numberInput += key;
            }
            else{
                this.numberInput += key;
                this.searchGsm(this.numberInput)
            }
        },
        call(){
            if(this.status==='online'){
                var tel = this.numberInput
                this.$root.$refs.sip.call(tel)
            }
            else{
                alert('Şuanda çevrimiçi değilsiniz!')
            }
        },
        transfer(){
            var tel = this.numberInput
            this.$root.$refs.sip.makeTransfer(tel,'online')
        },
        deleteNumber(){
            this.numberInput = this.numberInput.slice(0, -1);
            this.searchGsm(this.numberInput)
        },
        searchGsm(event){
            var num = event
            let filterEnd={
                "searchMode":"contacts",
                "name":"default",
                "ands":[{
                    fieldName: "gsm",
                    filterType: "contacts",
                    operator: "contains",
                    value: num
                }]
            }
            var params = {}
            params.pagingSize=this.pagingSize
            params.pagingOffset=this.pagingOffset
            params.filter=filterEnd
            params.blockLoadingBar=true
            
            axios({
                method:'POST',  
                url:'/getContacts',
                baseURL: this.baseUrl,
                data:params,
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(res.data.status.code==="0"){
                    this.personArray = []
                    for(let contact of res.data.content.contacts){
                        if(contact.gsm && Array.isArray(contact.gsm)){
                            for(let i of contact.gsm){
                                let n = i.toString()
                                if(n.includes(num)){
                                    var obj = {
                                        name : contact.n,
                                        surname : contact.sn,
                                        gsm : n
                                    }
                                    if(contact.organization && contact.organization.length!==0 && contact.organization[0]!=null){
                                        obj.organizationName = contact.organization[0].name
                                    }
                                    else{
                                        obj.organizationName = "Firma Yok"
                                    }
                                    this.personArray.push(obj)
                                }
                            }
                        }
                        else if(contact.gsm && typeof contact.gsm === 'string'){
                            if(contact.gsm.includes(num)){
                                var obj = {
                                    name : contact.n,
                                    surname : contact.sn,
                                    gsm : contact.gsm
                                }
                                if(contact.organization && contact.organization.length!==0 && contact.organization[0]!=null){
                                    obj.organizationName = contact.organization[0].name
                                }
                                else{
                                    obj.organizationName = "Firma Yok"
                                }
                                this.personArray.push(obj)
                            }
                        }
                    }
                    this.$emit("personList",this.personArray)
                }else{
                    this.$notify({
                        group: 'foo',
                        type: 'error',
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc
                    })
                }
            })
        },
        getAgents(){
            axios({
                method:'POST',
                url:'/getCompanySipAgentsWithStatus',
                baseURL: this.baseUrl,
                data:{
                blockLoadingBar:true
                },
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(res.data){

                }else{
                    this.$notify({
                        group: 'foo',
                        type: 'error',
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc
                    })
                }
            })
        },
        scrollfunctionOfNumerator:function (scrollYEmit,clientHeightEmit,scrollHeightEmit){
            this.bottom = this.bottomVisible(scrollYEmit,clientHeightEmit,scrollHeightEmit)
        },
        bottomVisible(scrollYEmit,clientHeightEmit,scrollHeightEmit) {
            
            const scrollY = scrollYEmit
            const visible = clientHeightEmit
            const pageHeight = scrollHeightEmit
            const bottomOfPage = visible + scrollY >= pageHeight
            
            return bottomOfPage || pageHeight < visible
        },
    },

    mounted() {
        this.searchGsm("")
    },
    computed: {
        ...mapState([
            'baseUrl'
        ]),
        ...mapGetters(['sipSettingsId'])
    },
    created() {
        this.$root.$refs.numerator = this
    },
}
</script>
<style scoped>
    * {
        margin: 0;
    }
    .content {
        width: 240px;
        /* height: 370px; */
        background: #333333;
        color: white;
    }
    
    .content > #inputArea {
        border-bottom: 1px solid #4F4F4F;
    }
    table {
        border-collapse: separate;
    }

    body {
        text-align:center; 
    }	
    #keypad {
        margin: auto;
        border-spacing: 10px;
    }

    #keypad tr td {
        vertical-align:middle; 
        text-align:center; 
        border: none;
        padding: 0.6rem 1rem;
        font-size:28px; 
        font-weight:bold; 
        cursor:pointer; 
        background-color:transparent; 
        color:#CCCCCC;
        border: 2px solid #FFFFFF;
        border-radius: 50%;
        }
    #keypad tr td:hover {
        background-color:#FFFFFF; 
        color: #333333;;
    }
    .display {
        margin: 0;
        max-width: 200px;
        padding: 1rem 1rem 1rem 2rem;
        background: transparent;
        border: none;
        color: #FFFFFF;
        font-size: 25px;
        line-height: 30px;
        text-align: right;
    }
    #message {
        text-align:center; 
        color:#009900; 
        font-size:14px; 
        font-weight:bold; 
        display:none;
    }
    .backspace {
        font-size: 30px;
        cursor: pointer;
    }
    .call-icon {
        margin: 0.7rem auto;
        font-size: 30px;
        background: #35C677;
        padding: 0.7rem;
        border-radius: 50%;
    }
    .forward-btn {
        margin: 1rem auto 1rem auto;
        background: #1991EB;
        padding: 0.5rem 4rem;
        border-radius: 30px;
        color: #FFFFFF;
        font-weight: 500;
        font-size: 14px;
    }

</style>